import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { AppMainComponent } from '../../../../../app.main.component';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CaseService } from '../../case.service';
import { ObjectNames, Status,Severity} from '../../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { AppMainService } from 'src/app/app-main.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { map } from 'rxjs/operators';
import { element } from 'protractor';
import { Answer } from '../../../constants/constants';


export interface categoryDefaultDetails {
  categoryId: number, 
  isDefault: boolean
}
@Component({
  selector: 'app-case-fields-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  providers: [ConfirmationService]
})
export class CaseFieldCategoryComponent implements OnInit, OnChanges {

  @Input() casesAllCategories;
  @Input() addNewField: any;

  @Output() reLoadCategories = new EventEmitter();
  @Output() showEditCategory = new EventEmitter();

  casesCategories = [];
  selectedCategory;
  addEditCaseSubHeader ='';
  caseSubCategory = {
    id:  0,
    name: '',
    description: '',
    parentCategoryId: 0,
    resolutionDays: null,
    userGroupId: null,
    defaultUserId: null,
    isActive: true,
    isDefault: false
  };
  displayAddCaseSubData:boolean = false;
  caseDataTypes = [
    { id: 1, name: "Source", code: "source" },
    { id: 2, name: "Category", code: "category" },
    { id: 3, name: "Priority", code: "priority" }
  ]
  invalidData = false;

  displayPermission = false;
  allUserGroup = [];
  selectedGroup;
  allUsers = [];
  selectedUser;

  grpAccessPermissionData = {
    subCategoryId: 0,
    userGroupId: 0,
    defaultUserIds: []
  }

  userIds: Array<number>;
  answertypeConstants = Answer;
  isDisabledCatName: boolean = false;
  
  subCategoryForm: FormGroup;
  defaultValueCheck: boolean = false;

  constructor(
    private fb: FormBuilder, 
    private app: AppMainComponent, 
    private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    private caseConfigService: CaseService,
    private service: ConfigurationService,
    private appMainService: AppMainService,
    private titlecasePipe: TitleCasePipe ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if(changes.casesAllCategories && changes.casesAllCategories.currentValue){
      const allCategories = changes.casesAllCategories.currentValue;
      this.casesCategories = allCategories.length ? allCategories.filter(categoryObj => categoryObj.parentCategoryId == 0 || categoryObj.parentCategoryId == null) : [];
      if(allCategories.length){
        allCategories.map(category =>{
          const subCategories = allCategories.filter(catObj => catObj.parentCategoryId == category.id)
          category.subCategory = subCategories;
        })
      }
      this.getUserGroupList();
    }

  }

  ngOnInit(): void {
    this.prepareSubCategoryForm();
  }

  delCategory(c) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Category?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {

        this.appMainService.isShowSpinner('DeleteCaseCategory');
        this.service.deleteCaseCategory(c.id).subscribe(
          resp =>{
            this.reLoadCategories.emit({})
            this.appMainService.isHideSpinner('DeleteCaseCategory');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case category deleted successfully...' });
          },
          err =>{
            this.appMainService.isHideSpinner('DeleteCaseCategory');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
          }
        );
      },
      reject: () => {
      }
    });
  }


  showEditCaseData(c, s) {
    this.showEditCategory.emit({data:c, caseDataType: s})
  }

  showAddCaseSubData(data) {
    this.selectedGroup = null;
    this.selectedUser = null;
    this.allUsers = null;
    this.selectedCategory = JSON.parse(JSON.stringify(data));
    this.addEditCaseSubHeader = 'Add Sub Category Data';
    this.prepareSubCategoryForm(data);
    this.getUserGroupList();
    this.displayAddCaseSubData = true;
    
  }

  prepareSubCategoryForm(data?: any): void {
    this.subCategoryForm = this.fb.group({
      id: [0],
      name: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      description: [''],
      parentCategoryId: [data?.id || null],
      resolutionDays: [5, [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      userGroupId: [null, Validators.required],
      defaultUserId: [null],
      isActive: [true],
      isDefault: [false]
    });
  }

  get name() {return this.subCategoryForm.get('name');}
  get resolutionDays() {return this.subCategoryForm.get('resolutionDays');}
  get userGroupId() {return this.subCategoryForm.get('userGroupId');}


  saveCaseSubDataAdd() {
    if (this.subCategoryForm.valid){
      const subCatFormData = {
        id: this.subCategoryForm.value['id'],
        name: this.subCategoryForm.value['name'],
        description: this.subCategoryForm.value['description'],
        parentCategoryId: this.subCategoryForm.value['parentCategoryId'],
        resolutionDays: this.subCategoryForm.value['resolutionDays'],
        userGroupId: this.subCategoryForm.controls['userGroupId'].value.id,
        defaultUserId: this.subCategoryForm.controls['defaultUserId'].value?.id,
        isActive: this.subCategoryForm.value['isActive'],
        isDefault: this.subCategoryForm.value['isDefault']
      }
      // let duplicateRecord;

      // if (subCatFormData.name != null){
      //   duplicateRecord = this.selectedCategory.subCategory != null
      //           ? this.selectedCategory.subCategory.find(
      //                 (obj) =>
      //                     obj.name.toLowerCase().trim() == subCatFormData.name.toLowerCase().trim() &&
      //                     obj.id !== subCatFormData.id
      //             )
      //           : false;

      // }
      // else {
      //   duplicateRecord = this.selectedCategory.subCategory != null
      //           ? this.selectedCategory.subCategory.find(
      //                 (obj) =>
      //                     obj.name.toLowerCase().trim() == subCatFormData.name.toLowerCase().trim()
      //             )
      //           : false;

      // }

      // // if (this.caseSubCategory.id) {
      // //   duplicateRecord = this.selectedCategory.subCategory != null ? this.selectedCategory.subCategory.find(obj => obj.name.toLowerCase().trim() == this.caseSubCategory.name.toLowerCase().trim() && obj.id !== this.caseSubCategory.id) : false;
      // // } else {
      // //   duplicateRecord = this.selectedCategory.subCategory != null ?  this.selectedCategory.subCategory.find(obj => obj.name.toLowerCase().trim() == this.caseSubCategory.name.toLowerCase().trim()) : false;
      // // }

      // if (duplicateRecord) {
      //   this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Name is already exist...' });
      // } 
      // else
      // {
        // if (this.caseSubCategory.name == "" || this.caseSubCategory.resolutionDays == null 
        //     || this.selectedGroup?.id == null){
        //   this.messageService.add({ severity: 'warn', summary: 'Warning', detail: "Name, Resolution days, and Group are required" });
        //   return;
        // }
        // if (this.caseSubCategory?.resolutionDays < 0){
        //   this.messageService.add({ severity: 'warn', summary: 'Warning', detail: "Negative value should not be stored as resolution date"});
        //   return;
        // }
        // this.caseSubCategory.userGroupId = this.selectedGroup?.id;
        
        subCatFormData.defaultUserId = subCatFormData.defaultUserId == -1 ? null : subCatFormData.defaultUserId;
        if (this.addEditCaseSubHeader == "Add Sub Category Data") {
          this.appMainService.isShowSpinner('AddCaseSubCategory');
          this.caseConfigService.addCaseSubCategory(subCatFormData).subscribe(
            resp =>{
              this.displayAddCaseSubData = false;
              this.reLoadCategories.emit({});
              this.subCategoryForm.reset();
              this.appMainService.isHideSpinner('AddCaseSubCategory');
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case subcategory added successfully...' });
          },
          err =>{
              //this.displayAddCaseSubData = false;
              this.appMainService.isHideSpinner('AddCaseSubCategory');
              this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
          }
        )
      }
      else {
        this.appMainService.isShowSpinner('updatedCaseSubCategory');
        this.caseConfigService.addCaseSubCategory(subCatFormData).subscribe(
          resp =>{
              this.displayAddCaseSubData = false;
              this.reLoadCategories.emit({});
              this.subCategoryForm.reset();
              this.appMainService.isHideSpinner('updatedCaseSubCategory');
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case subcategory updated successfully...' });
          },
          err =>{
              //this.displayAddCaseSubData = false;
              this.appMainService.isHideSpinner('updatedCaseSubCategory');
              this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
          }
        )
      }
    //}
   }
 }

  showEditCaseSubData(data, sub) {
    this.selectedGroup = null;
    this.selectedUser = null;
    this.selectedCategory = data;
    this.setEditSubCategoryForm(sub);

    this.addEditCaseSubHeader = 'Edit Sub Category Data';
    this.displayAddCaseSubData = true;
    
    if (sub?.userGroupId != null){
      
      this.processSelectedGroupAndUsers(sub?.userGroupId, sub?.defaultUserId);
    }
  }

  setEditSubCategoryForm(subCategoryData: any): void {
    this.subCategoryForm = this.fb.group({
      id: [subCategoryData.id],
      name: [subCategoryData.name, [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      description: [subCategoryData?.description],
      resolutionDays: [subCategoryData?.resolutionDays, [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      parentCategoryId: [subCategoryData?.parentCategoryId],
      userGroupId: [subCategoryData?.userGroupId, Validators.required],
      defaultUserId: [subCategoryData?.defaultUserId],
      isActive: [subCategoryData?.isActive],
      isDefault: [subCategoryData?.isDefault]
    });
    this.defaultValueCheck  = this.subCategoryForm.value['isDefault'];
  }

  delSubCategory(data, c) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this subCategory?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('DeleteCaseCategory');
        this.service.deleteCaseCategory(c.id).subscribe(
          resp =>{
            this.reLoadCategories.emit({})
            this.appMainService.isHideSpinner('DeleteCaseCategory');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case SubCategory deleted successfully...' });
          },
          err =>{
            this.appMainService.isHideSpinner('DeleteCaseCategory');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
          }
        );
      },
      reject: () => {
      }
    });
  }

  showPermission(data, sub): void {
    this.selectedCategory = data;
    this.caseSubCategory = JSON.parse(JSON.stringify(sub));
    this.getUserGroupList();
    this.displayPermission = true;
  }

  getUserGroupList() {
    this.caseConfigService.getUserGroups(this.app.user.organizationId)
      .pipe(
        map(res => {
          return res.map(group => {
            let groupOwnersList = [];
            group.groupOwners.map(groupOwner => {
              groupOwnersList.push(groupOwner.name);
            })
            group.ownerList = groupOwnersList.join(', ');
            if (group.parentGroup) {
              delete group.parentGroup
            }
            return group;
          })
        })
      ).subscribe(resp => {
        this.allUserGroup = [...resp];
        this.allUserGroup.sort(function (a, b) {
          var nameA = a.group.name.toLowerCase(), nameB = b.group.name.toLowerCase()
          if (nameA < nameB) //sort string ascending
            return -1
          if (nameA > nameB)
            return 1
          return 0 //default return value (no sorting)
        })

        // -- Selected group will be changed when default all users will come accroding to new logic

        let group = this.allUserGroup != null ? this.allUserGroup.filter(x => x.name == "All users") : null;
        this.selectedGroup = Object.assign({}, ...group);
        
        if (this.selectedGroup == null){
          group = this.allUserGroup[0];
          this.selectedGroup = Object.assign({}, ...group);
        }
        this.subCategoryForm.patchValue({userGroupId: this.selectedGroup});
        //this.selectedUser = this.selectedGroup?.users;
        this.getUsersList();
        //this.getGrpAccessPersmissionDetailsById(this.caseSubCategory.id);
        //console.log('updated this.allUserGroup', this.allUserGroup)
      });
  }

  getUsersList(event?): void {
    this.allUsers = [];
    this.selectedUser = null;
    let allUserGroup = [];
    if(event?.value?.id != null){
       allUserGroup = this.allUserGroup.filter(element => element.id == event?.value?.id);
    }
    else {
       allUserGroup = this.allUserGroup.filter(element => element.id == this.selectedGroup.id);
    }
    
    //this.allUsers = this.allUserGroup.filter(element => element.id == event?.value?.id ? event?.value?.id : this.selectedGroup.id)[0].users;
    this.allUsers = allUserGroup[0]?.users;
    const doubleSelectUser = this.allUsers ? this.allUsers.find(x => x.name == "Select a User") : null;
    if (doubleSelectUser == null && this.allUsers != null){
      this.allUsers.unshift({
        id: -1,
        name: "Select a User"
      });
    }
  }

  processSelectedGroupAndUsers(groupId: number, userId: number): void {
    let group = [];
    if (groupId != null){
      group = this.allUserGroup != null ? this.allUserGroup.filter(x => x.id == groupId): [];
      this.selectedGroup = Object.assign({}, ...group);
    }
    this.subCategoryForm.patchValue({userGroupId: this.selectedGroup});
      this.allUsers = group != null ? group[0].users : [];
      const checkValue = this.allUsers.find((x => x.id == -1));
      if (checkValue?.id != -1){
        this.allUsers.unshift({
          id: -1,
          name: "Select a User"
        });
      }
      
      let user = this.allUsers != null ? this.allUsers.filter(x => x.id == userId) : [];
      this.selectedUser = Object.assign({}, ...user);
      this.subCategoryForm.patchValue({defaultUserId: this.selectedUser});
    
  }

  onChangeDefaultUser($event?){
    this.userIds = this.selectedUser.map(x => x.id).sort((a, b) => a -b);
  }

  makeIsDefault(data : any): void {
    if (data){
      const categoryData : categoryDefaultDetails = {
        categoryId: data?.id, 
        isDefault: true 
      }
      this.appMainService.isShowSpinner('isDefaultField');
      this.caseConfigService.updateCategoryIsDefaultField(categoryData).then((response) => {
        this.appMainService.isHideSpinner('isDefaultField');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Category Updated successfully...' });
        this.reLoadCategories.emit({});

      }).catch((error) => {
        this.appMainService.isHideSpinner('isDefaultField');
        this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: error.error?.Message == null
                    ? "Error Occured, try again later"
                    : error.error?.Message,
        });
        this.reLoadCategories.emit({});
        
      })
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail:'Data not loaded, try again later' });
    }
  };

  onValidateName(Data) {
    if (Data.target.value.trim() == "" || Data.target.value.trim() == undefined) {
      this.isDisabledCatName = true;
    }
    else {
      if ((this.caseSubCategory.name.trim() != "" || this.caseSubCategory.name != ""))// && this.caseDataTypes[this.caseTypeId].name !='Select Field Type') {
      {
        this.isDisabledCatName = false;
      }
    }
  };

  cancelCaseSubDataAdd(): void {
    this.displayAddCaseSubData = false;
    this.isDisabledCatName = false;
  };


}
